//this function replaces the params in the path with the actual values
//let's assume we have a url like /details/:id with id any guid and we want to navigate to /details/:id/related
//the above code will take the id from the url and replace it in the new url
export const getFormattedPathUrl = (path, locationParams) => {
  let url = path;
  for (let index = 0; index < Object.keys(locationParams).length; index++) {
    const param = Object.keys(locationParams)[index];
    url = url.replace(`:${param}`, locationParams[param]);
  }
  return url;
};
